import { getFiltersWithQuotes, safeDecode } from "../functions";
import { NOT_FILTER_NAMES } from "../types";

export const useDecoder = () => {
    const decodeStrings = (stringParams: string) => {
        if (stringParams) {
            const pairs = stringParams.split("&");

            const result = pairs.map(pair => {
                const [key, value] = pair.split("=");
                const valueArray: string[] = value.split(",");

                const filtersWithQuotes: string[] = getFiltersWithQuotes();

                if (filtersWithQuotes.includes(key)) {
                    const quotedAndSeperated = valueArray
                        .map(val => `"${val}"`)
                        .join();

                    const decodedValue = safeDecode(quotedAndSeperated);

                    return `${key}=${decodedValue}`;
                }

                return `${key}=${key === NOT_FILTER_NAMES.Query ? value : safeDecode(value)}`;
            });

            return result.join("&");
        }

        return stringParams;
    };

    const decodeArray = (arr: string[]) =>
        arr.map(element => safeDecode(element));

    return { decodeStrings, decodeArray };
};
